import { render, staticRenderFns } from "./DocketBooks.vue?vue&type=template&id=24dc76be&"
import script from "./DocketBooks.vue?vue&type=script&lang=js&"
export * from "./DocketBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports